<template>
  <div
    :class="`flex flex-none h-fit w-full border-t-black-500/20 border-t-4 ${bgClass}`"
    v-if="cart && cart.length > 0"
  >
    <div
      class="w-full md:w-[90%] mx-auto px-2 py-3 grid grid-cols-3 md:grid-cols-2 gap-3 md:gap-5"
    >
      <router-link to="/cart" class="w-full">
        <u-i-button :class="`w-full ${secondaryButtonClasses}`"
          >My Cart</u-i-button
        >
      </router-link>
      <router-link to="/checkout" class="w-full col-span-2 md:col-span-1">
        <u-i-button
          :class="`w-full ${primaryButtonClasses} flex justify-center`"
          >Checkout
          <price-display>{{
            (totalCart / 100).toFixed(2)
          }}</price-display></u-i-button
        >
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapState, mapWritableState } from "pinia";
import { useSessionStore } from "@/app-store/session";
import { getCartTotal } from "@/utils/ProductFormulas";
import UIButton from "@/components/UI/UIButton";
import { useAppStore } from "@/app-store/app";
import PriceDisplay from "@/components/UI/priceDisplay";

export default {
  name: "ActionButtons",
  components: {
    PriceDisplay,
    UIButton,
  },
  computed: {
    ...mapWritableState(useSessionStore, ["cart"]),
    ...mapState(useAppStore, ["layoutConfig"]),
    bgClass() {
      const { layoutConfig } = this;
      if (!layoutConfig || !layoutConfig.actionbar) return "bg-color-first";
      return `bg-color-${layoutConfig.actionbar.containerColor}`;
    },
    primaryButtonClasses() {
      const { layoutConfig } = this;
      if (!layoutConfig || !layoutConfig.actionbar)
        return "bg-color-third text-white";
      let shapeClass = "rounded-none";
      switch (layoutConfig.actionbar.primaryButtonShape) {
        case "rounded":
          shapeClass = "rounded-xl";
          break;
        case "full-rounded":
          shapeClass = "rounded-full";
          break;
      }
      return `${shapeClass} bg-color-${layoutConfig.actionbar.primaryButtonBackgroundColor} text-color-${layoutConfig.actionbar.primaryButtonTextColor} font-${layoutConfig.actionbar.primaryButtonFont} border-2 border-color-${layoutConfig.actionbar.primaryButtonBorderColor} max-md:text-xl md:text-${layoutConfig.actionbar.primaryButtonTextSize}`;
    },
    secondaryButtonClasses() {
      const { layoutConfig } = this;
      if (!layoutConfig || !layoutConfig.actionbar)
        return "bg-color-third text-white";
      let shapeClass = "rounded-none";
      switch (layoutConfig.actionbar.secondaryButtonShape) {
        case "rounded":
          shapeClass = "rounded-xl";
          break;
        case "full-rounded":
          shapeClass = "rounded-full";
          break;
      }
      return `${shapeClass} bg-color-${layoutConfig.actionbar.secondaryButtonBackgroundColor} text-color-${layoutConfig.actionbar.secondaryButtonTextColor} font-${layoutConfig.actionbar.secondaryButtonFont} border-2 border-color-${layoutConfig.actionbar.secondaryButtonBorderColor} max-md:text-xl md:text-${layoutConfig.actionbar.secondaryButtonTextSize}`;
    },
    totalCart() {
      return getCartTotal(this.cart);
    },
  },
};
</script>

<style scoped></style>
